import React from "react";
import Login from "@/pages/Login";

const UnauthenticatedApp = () => {
    return (
        <Login />
    )
}

export default UnauthenticatedApp